// เวลาไทยเสมอ ไม่ตามนาฬิกาเครื่อง (Purim เดินทางต่างประเทศบ่อย — สั่ง 28 ก.ย. 2026)
// ทุกวันที่/เวลาที่โชว์ และทุกการตัดสินว่าเป็น "วันไหน/เดือนไหน/ปีไหน" ต้องเป็น Asia/Bangkok (UTC+7 ไม่มี DST)
// ⚠️ timestamp ที่เก็บลง DB / ส่ง API ยังเป็น UTC (toISOString) เหมือนเดิม — ไฟล์นี้ใช้ตอนแสดงผล/แบ่งวันเท่านั้น
// การแสดงผล: ใส่ { timeZone: TZ } ใน toLocaleDateString / toLocaleString / toLocaleTimeString ทุกจุด
export const TZ = 'Asia/Bangkok';

// -u-ca-gregory-nu-latn: บังคับปี ค.ศ. + เลขอารบิก กันเครื่องที่ตั้งปฏิทินพุทธ/เลขไทยไว้ (iPhone ไทย)
const PARTS = new Intl.DateTimeFormat('en-US-u-ca-gregory-nu-latn', { timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric' });

// { y, m (1-12), d } ตามปฏิทินไทย (ค.ศ.) ของ instant นั้น — รับ Date / ISO string / ms · ค่าเสีย = NaN (เหมือน getFullYear เดิม)
export function thParts(v) {
  const t = v instanceof Date ? v : new Date(v);
  if (Number.isNaN(t.getTime())) return { y: NaN, m: NaN, d: NaN };
  const o = {};
  for (const p of PARTS.formatToParts(t)) o[p.type] = p.value;
  return { y: Number(o.year), m: Number(o.month), d: Number(o.day) };
}

// 'YYYY-MM-DD' ตามวันที่ไทยของ instant นั้น (ใช้กับ <input type="date"> / เทียบวัน) · ค่าเสีย = ''
export function thDay(v) {
  const { y, m, d } = thParts(v);
  if (Number.isNaN(y)) return '';
  return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
}

// วันนี้ (ไทย) เป็น 'YYYY-MM-DD'
export const thToday = () => thDay(new Date());

// วันนี้ (ไทย) + n วัน เป็น 'YYYY-MM-DD' — ไทยไม่มี DST บวกทีละ 24 ชม. = บวก 1 วันพอดี
export const thAddDays = n => thDay(Date.now() + n * 86400000);
